import React, { createContext } from "react";
import { useStudioManager, type StudioManager } from "./use-studio-manager";

export const StudioContext = createContext<StudioManager>({
  status: "closed",
  open: () => null,
  close: () => null,
  postTokenToWindow: () => Promise.resolve(),
  focusStudio: () => null,
  studioUrl: null,
});

export function StudioManager({ children }: { children: React.ReactNode }) {
  const manager = useStudioManager();

  return (
    <StudioContext.Provider value={manager}>{children}</StudioContext.Provider>
  );
}
